<template>
  <div class="nav-list-box">
    <div class="nav-list">
      <div class="imgBox" v-for=" (item, index) in list " :key="index">
        <img :src="item.img" alt="">
        <div class="imgBox-text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [
        { text: "Smart Mapping", img: "https://mediakit.enabot.com/eboX/img/pc/nav1.png"},
        { text: "Fall & Crying Alert", img: 'https://mediakit.enabot.com/eboX/img/pc/nav2.png' },
        { text: "Photo & Video", img: 'https://mediakit.enabot.com/eboX/img/pc/nav3.png' },
        { text: "Auto Back-to-Charge", img: 'https://mediakit.enabot.com/eboX/img/pc/nav4.png' },
        { text: "Home Security", img: 'https://mediakit.enabot.com/eboX/img/pc/nav5.png' },
        { text: "Two-Way Communication", img: 'https://mediakit.enabot.com/eboX/img/pc/nav6.png' },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-list-box{
  .nav-list {
    max-width: 903px;
    margin: 0 auto 40px;
    // margin-bottom: 41px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .imgBox {
      width: 288px;
      margin-bottom: 79px;
      font-size: 24px;

      img {
        width: 60px;
        height: 60px;
        margin: 0 auto;
      }
    }
    .imgBox-text{
      margin-top: 10px;
      font-size: 24px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 24px;
    }
  }
}
</style>